export default __webpack_public_path__ + "images/XG.2bc698a.png";